<a [href]="url" target="_blank" (click)="openInOpalsIfEnabled($event)">
    <ng-content></ng-content>
</a>
